import { Injectable } from '@angular/core'
import { Loader } from '@googlemaps/js-api-loader'
import { from } from 'rxjs'

import { environment } from '../../../../environments'

@Injectable({
  providedIn: 'root',
})
export class GoogleMapsApiLoaderService {

  private loader = new Loader({
    apiKey: environment.googleMapsApiKey,
    libraries: ['places'],
  })
  google$ = from(this.loader.load())
}
